/**
 * Defines the constants used by the Mobile module.
 * @file
 * @author Benjamin Listwon <ben@thebrandingfarm.com>
 * @author Jason Haddix <jason@thebrandingfarm.com>
 */

 export const VUEX_GLOBAL_SET_MOBILE_STATE    = 'VUEX_GLOBAL_SET_MOBILE_STATE'
 export const VUEX_GLOBAL_SET_BROWSER_STATE   = 'VUEX_GLOBAL_SET_BROWSER_STATE'
 export const VUEX_GLOBAL_SET_BROWSER_NAME    = 'VUEX_GLOBAL_SET_BROWSER_NAME'
 export const VUEX_GLOBAL_SET_BROWSER_VERSION = 'VUEX_GLOBAL_SET_BROWSER_VERSION'
 export const VUEX_GLOBAL_SET_BROWSER_BLOCKED = 'VUEX_GLOBAL_SET_BROWSER_BLOCKED'
 export const VUEX_GLOBAL_SET_MOBILE_DEVICE   = 'VUEX_GLOBAL_SET_MOBILE_DEVICE'
